import React, { useEffect, useMemo } from "react";
import { PropsWithChildren } from "react";
import { ViewListData, ViewListContext } from "@/context/ViewListContext";

export function ViewListItem(props: PropsWithChildren) {
  return <>{props.children}</>;
}

type ViewListProps = PropsWithChildren<ViewListData> & {
  setStepsCount: (count: number) => void;
  content?: React.ReactNode[];
  debug?: string;
};

export default function ViewList({ debug, content, children, ...props }: ViewListProps) {
  const { activeStep } = props;

  const steps = useMemo(() => {
    const res = content
      ? [...content]
      : (React.Children.toArray(children).filter(
          (step) => React.isValidElement(step) && step.type === ViewListItem,
        ) ?? []);

    return res;
  }, [content, children]);

  useEffect(() => {
    props.setStepsCount(steps.length);
  }, [steps.length]);

  return (
    <ViewListContext.Provider value={props}>
      {steps[Math.min(activeStep, steps.length - 1)]}
    </ViewListContext.Provider>
  );
}
